// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePoolGetBody = {
  poolId: string;
};

export type typePoolGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    pool: {
      poolId: string;
      poolRefId?: string | null;
      name: string;
      sportKey: string;
      leagueKey: string;
      seasonYear: number;
      contestType: "survivor" | "squares" | "stripCard" | "pickem";
      joinPolicy: "open" | "approval";
      visibility: "public" | "private";
      autoApprove: boolean;
      memberSharingEnabled: boolean;
      chatEnabled: boolean;
      createdFromQuickStartId?: string | null;
      commissionerPreamble?: string | null;
      status: "active" | "archived";
      createdAt: string;
      bannerImageUrl?: string | null;
      maxMembers: number | null;
    };
    viewerPoolRole: "owner" | "admin" | "member";
    activeMemberCount: number;
    pendingMemberCount: number;
    statusLabel?: string | null;
  };
};

export type typePoolGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePoolGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePoolGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPoolGetBody = {
  type: "object",
  properties: { poolId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["poolId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPoolGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPoolGetBody);
  }

  return async function postPoolGet(
    payload: typePoolGetBody,
  ): Promise<typePoolGetOutput200 | typePoolGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPoolGet" failed before calling the network. #43a34bc8d829`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#43a34bc8d829" },
        },
        data: null,
      } as typePoolGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/pool/get`,
      httpMethod: "POST",
      options,
    })) as typePoolGetOutput200 | typePoolGetOutput400;
  };
}
